import React from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const BreakoutDecorator = {
  rule: () => true,
  decorate: ({ node, element, isRoot, context }) => {
    if (!isRoot) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, element);
    }
    const breakoutSettings = context.theme.breakout;
    if (!breakoutSettings) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, element);
    }
    const breakout = breakoutSettings.rule({ node });
    return /* @__PURE__ */ React.createElement("div", __spreadValues({}, { "data-breakout": breakout }), element);
  }
};

export { BreakoutDecorator };
//# sourceMappingURL=breakoutDecorator.js.map
